/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import {
  COMPONENT_OUTPUT_HTML_STATIC_FILE_CROSS_ORIGIN_TYPE_ANONYMOUS,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_CROSS_ORIGIN_TYPE_USE_CREDENTIALS,
} from '../types/ComponentHtmlOutputStaticFileCrossOrigin.type';
import {
  COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_NO_REFERRER,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_NO_REFERRER_WHEN_DOWNGRADE,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_ORIGIN,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_ORIGIN_WHEN_CROSS_ORIGIN,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_SAME_ORIGIN,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_STRICT_ORIGIN,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_STRICT_ORIGIN_WHEN_CROSS_ORIGIN,
  COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_UNSAFE_URL,
} from '../types/ComponentHtmlOutputStaticFileReferrerPolicy.type';
import { COMPONENT_OUTPUT_HTML_STATIC_FILE_TYPE_CSS } from '../types/ComponentHtmlOutputStaticFileType.type';

/**
 * The dxp component html output css file entity type.
 * @export
 */
export type EntityComponentHtmlOutputCssFile = io.TypeOf<typeof ComponentHtmlOutputCssFile>;

/**
 * The dxp component html output css file entity definition.
 * @export
 */
export const ComponentHtmlOutputCssFile = io.intersection(
  [
    io.type({
      filepath: io.string,
    }),
    io.partial({
      crossorigin: io.union([
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_CROSS_ORIGIN_TYPE_ANONYMOUS),
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_CROSS_ORIGIN_TYPE_USE_CREDENTIALS),
      ]),
      referrerpolicy: io.union([
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_NO_REFERRER),
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_NO_REFERRER_WHEN_DOWNGRADE),
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_ORIGIN),
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_ORIGIN_WHEN_CROSS_ORIGIN),
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_SAME_ORIGIN),
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_STRICT_ORIGIN),
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_STRICT_ORIGIN_WHEN_CROSS_ORIGIN),
        io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_UNSAFE_URL),
      ]),
      type: io.literal(COMPONENT_OUTPUT_HTML_STATIC_FILE_TYPE_CSS),
    }),
  ],
  `ComponentHtmlOutputCssFile`,
);
